var React = require('react');

function Bar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18,0c-2.578,0-4.823,1.616-5.659,4H2.765c-1.142,0-2.152.695-2.573,1.771-.41,1.045-.16,2.161.676,2.934l6.668,6.16c.434.395.936.667,1.465.818v6.317h-3c-.553,0-1,.448-1,1s.447,1,1,1h8c.553,0,1-.448,1-1s-.447-1-1-1h-3v-6.318c.53-.152,1.034-.425,1.471-.823l3.483-3.218c.655.238,1.342.358,2.046.358,3.309,0,6-2.691,6-6S21.309,0,18,0Zm-6.881,13.386c-.637.581-1.6.58-2.232.005L2.199,7.214c-.271-.251-.208-.555-.146-.713.095-.242.331-.501.711-.501h14.471c.38,0,.616.259.711.501.062.158.126.461-.171.735l-6.656,6.149Zm6.881-3.386c-.087,0-.174-.003-.26-.009l1.418-1.31c.811-.75,1.061-1.865.65-2.91-.421-1.076-1.432-1.771-2.573-1.771h-2.703c.698-1.216,2.002-2,3.468-2,2.206,0,4,1.794,4,4s-1.794,4-4,4Z"}));
}

Bar.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Bar;

Bar.default = Bar;
